export const TEXTS = {
  TITLE: 'Введите название группы адресов',
  LABEL: 'Название',
  INPUT_PLACEHOLDER: 'Например, экраны над кассой',
  SAVE_BUTTON_TEXT: 'Далее',
  NOTIFICATION_SUCCESS_TEXT: 'Группа адресов переименована',
  NOTIFICATION_ERROR_TOO_LONG_TEXT: 'Максимальная длина названия группы адресов - 128 символов',
  CANCEL: 'Отмена',
};
